import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[appStoryblok]',
  standalone: true,
})
export class StoryblokDirective implements OnInit {
  private el = inject(ElementRef);
  @Input() appStoryblok = '';
  _editable: unknown;

  ngOnInit() {
    if (!this.appStoryblok || typeof this.appStoryblok === 'undefined') return;
    const options = JSON.parse(this.appStoryblok.replace('<!--#storyblok#', '').replace('-->', ''));
    this.el.nativeElement.setAttribute('data-blok-c', JSON.stringify(options));
    this.el.nativeElement.setAttribute('data-blok-uid', options.id + '-' + options.uid);
  }
}
